import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // 检查是否已登录（从localStorage中获取token）
  const isAuthenticated = localStorage.getItem('authToken');
  
  if (!isAuthenticated) {
    // 如果未登录，重定向到登录页面
    return <Navigate to="/login" replace />;
  }
  
  // 如果已登录，渲染子组件
  return children;
};

export default ProtectedRoute; 